import { useEffect, useState } from 'react';
export const useScrapingPriority = (documentKey, currentFileId) => {
    const sessionStorageKey = `${documentKey}_LAST_FILE_ID`;
    const [lastFileId] = useState(() => {
        const stored = sessionStorage.getItem(sessionStorageKey);
        return stored ? parseInt(stored, 10) : undefined;
    });
    const hasNewFile = Boolean(currentFileId && currentFileId !== lastFileId);
    useEffect(() => {
        if (currentFileId && currentFileId !== lastFileId) {
            sessionStorage.setItem(sessionStorageKey, currentFileId.toString());
        }
    }, [currentFileId, lastFileId, sessionStorageKey]);
    return {
        shouldPrioritizeScraping: hasNewFile,
        currentFileId,
    };
};
